import currency from './currency'
import measurement from './measurement'

export default {
  name: 'BaseInfoUnit',
  path: 'unit',
  meta: {
    label: 'unit',
    auth: 'unit'
  },
  component: {
    name: 'Unit',
    render(c) {
      return c('router-view')
    }
  },
  children: [currency, measurement]
}
